// @ts-nocheck

import GA from 'react-ga';

import { Target } from '../../client';
import config from '../../config/app.config';
import { CommonActionTypes } from '../../types/actions/common';

const { analytics } = config;

GA.initialize(analytics.trackingId, {
  debug: Target.__ENV__ !== 'production',
});

/* {
  category,
  action: description,
  label,
  value,
}*/

export const handledActionTypes = [CommonActionTypes.TRACKING];

const trackingMiddlewareHandler = ({ next, action }: HandlerProps) => {
  if (action.type === CommonActionTypes.TRACKING) {
    GA.event(action.options);
  }
  return next(action);
};

export default trackingMiddlewareHandler;
